import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heartLike",
  "use": "heartLike-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"heartLike\">\n  <defs>\n    <path id=\"heartLike_like-a\" d=\"M10,7 C9,2 3,3.35956667 3,8 C3,10.7250889 5.33333333,13.7250889 10,17 C14.6666667,13.6381333 17,10.6381333 17,8 C17,3.35956667 11,2 10,7 Z\" />\n  </defs>\n  <use xlink:href=\"#heartLike_like-a\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol